import { CRM_SYSTEMS_IDS } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen";
import { AirtableFieldDateOptionsTimeFormat, AirtableFieldDurationHoursOptions } from "@/types/crm/tables/question";
import z from "zod";

export const fieldDateOptionsSchema = z.object({
    year_only: z.boolean().optional(),
    // TODO UPDATE ACCORDING TO AIRTABLE, USE ENUM
    durationFormat: z.string().optional(),
    timeFormat: z.union([z.nativeEnum(AirtableFieldDateOptionsTimeFormat), z.nativeEnum(AirtableFieldDurationHoursOptions)]).optional(),
    timezone: z.string().optional(),
})

export const pickGroupRankOptionsSchema = z.object({
    groups: z.union([
        z.array(z.object({
            label: z.string(),
            value: z.string(),
        })),
        z.array(z.string()),
    ]),
    options: z.union([
        z.array(z.object({
            label: z.string(),
            value: z.string(),
        })),
        z.array(z.string()),
    ]),
})

export const fieldOptionsValueSchema = z.string();

export const fieldOptionsValueLabelSchema = z.object({
    label: z.string(),
    value: z.string(),
})

export const fieldOptionsSchema = z.union([
    z.array(fieldOptionsValueSchema), // For single select
    z.array(fieldOptionsValueLabelSchema),
    pickGroupRankOptionsSchema
])

export const fieldTypeContextStackSchema = z.array(z.object({
    field_type: z.string(),
    crm_system: z.enum(CRM_SYSTEMS_IDS),
}))